import { Component, forwardRef, OnInit } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { MimePurposeToBeRenamed } from '../../../../Model/Catalog/MimeModels/MimePurposeToBeRenamed';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';

@Component({
  selector: 'useraction-changemimepurposes',
  templateUrl: 'useraction-changemimepurposes.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionChangeMimePurposeComponent) }
  ]})
export class UserActionChangeMimePurposeComponent extends UserActionBaseComponent implements OnInit {
  loading = false;

  purposesGridDataSource: Array<MimePurposeToBeRenamed> = [];

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService
  ) {
    super(loginService, macroService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadPurposes();
  }

  loadPurposes() {
    return new Promise<void>((resolve) => {
      let selectedCatalogId = this.catalogService.selectedCatalogId;
      let customerId = this.loginService.currentUser.customerId;
      this.loading = true;

      this.purposesGridDataSource = new Array<MimePurposeToBeRenamed>();

      this.catalogService
        .getAllMimePurposesInCatalog(selectedCatalogId, customerId)
        .subscribe((purposes) => {
          this.setPurposes(purposes);
          this.loading = false;
          resolve();
        });
    });
  }

  setPurposes(purposes) {
    if (purposes) {
      for (var element of purposes) {
        let newItem = new MimePurposeToBeRenamed(element, null);
        this.purposesGridDataSource.push(newItem);
      }
    }
  }

  async canStartMacro() : Promise<boolean> {
    return this.purposesGridDataSource.length > 0;
  }

  createUserAction(): StartAction {
    let startAction = new StartAction();
    startAction.catalogId = this.catalogService.catalog.id;
    startAction.customerId = this.loginService.currentUser.customerId;
    startAction.actionType = 'ChangeMimePurposes';
    startAction.actionParameter = this.createParameterStringAsJsonString();
    return startAction;
  }

  createParameterStringAsJsonString(): string {
    let parameterJsonString = JSON.stringify({
      mimePurposesToBeRenamed: this.purposesGridDataSource
    });
    return parameterJsonString;
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.purposesGridDataSource = parsed.mimePurposesToBeRenamed;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
